import { translate } from '@comparacar/lib/src/translations'
import CheckIcon from '@mui/icons-material/Check'
import QuizIcon from '@mui/icons-material/Quiz'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

import AttributeBullet from './AttributeBullet'

interface iProviderBanner {
  provider: Provider
}

const ProviderBanner: React.FC<iProviderBanner> = ({ provider }) => {
  const { detail } = provider

  return (
    <Paper sx={{ p: 2.5 }}>
      <Stack spacing={4}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={{ xs: 'normal', sm: 'space-between' }}>
          <Typography variant="h6">Vantagens {provider.name}</Typography>
          {detail.contractUrl && (
            <Box>
              <Button variant="outlined" size="small" href={detail.contractUrl} target="_blank">
                {translate('ProviderBanner.button.seeContract')}
              </Button>
            </Box>
          )}
        </Stack>
        <Grid container rowSpacing={1.5}>
          {detail.bullets.map((bullet, i) => (
            <AttributeBullet key={i} icon={<CheckIcon fontSize="large" color="primary" />} text={bullet} />
          ))}
        </Grid>
        {!!detail.qa?.length && (
          <>
            <Divider />
            <Grid container spacing={4}>
              {detail.qa.map(({ question, answer }, i) => (
                <Grid key={i} size={6}>
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <QuizIcon color="primary" />
                    <Box>
                      <Typography variant="subtitle2">{question}</Typography>
                      <Typography variant="caption" component="div" lineHeight="12px" color="text.secondary">
                        {answer}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Stack>
    </Paper>
  )
}

export default ProviderBanner
